import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function NavWrap(props) {
  const {
    children,
    ...otherProps
  } = props;
  delete otherProps.activeKey;
  delete otherProps.activeHref;
  return /*#__PURE__*/_jsx("li", {
    className: "display-flex align-items-center",
    ...otherProps,
    children: children
  });
}
export default NavWrap;